<template>
  <validation-observer v-slot="{errors}">
    <sub-content-qa style="padding-left: 0px;">
      <b-auto-or-select v-model="Year"
                  class="mr-2"
                  v-checker
                  :items="yyyItems"
                  :search-input.sync="recYYSync"
                  @change="Day = ''"
                  v-mask="'###'"
                  maxlength="3"
                  :disabled="disabled"
                  label="民國年"
                  :rules="rules"
                  vname="民國年"
                  :vid="vid+'_Year'"
                  :error-messages-hidden="true"
                  mode="lazy"></b-auto-or-select>
        <b-auto-or-select v-model="Month"
                  class="mr-2"
                  v-checker
                  :items="mmItems(Year)"
                  :search-input.sync="recMMSync"
                  @change="Day = ''"
                  v-mask="'##'"
                  maxlength="2"
                  :disabled="disabled"
                  label="月"
                  :rules="rules"
                  vname="月"
                  :vid="vid+'_Month'"
                  :error-messages-hidden="true"
                  mode="lazy"></b-auto-or-select>
        <b-auto-or-select v-model="Day"
                  class="mr-2"
                  v-checker
                  :items="ddItems(Year,Month)"
                  :search-input.sync="recDDSync"
                  v-mask="'##'"
                  maxlength="2"
                  :disabled="disabled"
                  label="日"
                  :rules="rules"
                  vname="日"
                  :vid="vid+'_Day'"
                  :error-messages-hidden="true"
                  mode="lazy"></b-auto-or-select>
      </sub-content-qa>
    <error-messages :value="errors"></error-messages>
  </validation-observer>
</template>
<script>
import { policyChangedChecker, dateSelect } from '@/mixin'
export default {
  name: 'b-select-date',

  mixins: [policyChangedChecker, dateSelect],

  props: {
    value: {
      type: null
    },
    propYear: String,
    propMonth: String,
    propDay: String,
    disabled: Boolean,
    rules: String,
    vid: String,
    dateMode: {
      type: String,
      default: '1'
    }
  },

  data () {
    return {
      recYYSync: null,
      recMMSync: null,
      recDDSync: null,
      Year: '',
      Month: '',
      Day: ''
    }
  },

  computed: {
    innerDate () {
      if (this.Year && this.Month && this.Day) {
        switch (this.dateMode) {
          case '1': // YYY-MM-DD
            return this.Year + '-' + this.Month + '-' + this.Day
          case '2': // YYYMMDD
            return this.Year + this.Month + this.Day
          case '3': // YYY/MM/DD
            return this.Year + '/' + this.Month + '/' + this.Day
        }
      }
      return ''
    }
  },

  watch: {
    Year: {
      handler (newVal) {
        this.$emit('input-year', newVal)
      },
      immediate: true
    },
    Month: {
      handler (newVal) {
        this.$emit('input-month', newVal)
      },
      immediate: true
    },
    Day: {
      handler (newVal) {
        this.$emit('input-day', newVal)
      },
      immediate: true
    },
    value: {
      handler (newVal) {
        if (newVal) {
          switch (this.dateMode) {
            case '1': // YYY-MM-DD
              let dateAry = newVal.split('-')
              this.Year = dateAry[0]
              this.Month = dateAry[1]
              this.Day = dateAry[2]
              return
            case '2': // YYYMMDD
              if (newVal.length >= 7) {
                this.Year = newVal.substr(0, 3)
                this.Month = newVal.substr(3, 2)
                this.Day = newVal.substr(5, 2)
                return
              }
              return
            case '3': // YYY/MM/DD
              let dateAry3 = newVal.split('/')
              this.Year = dateAry3[0]
              this.Month = dateAry3[1]
              this.Day = dateAry3[2]
              return
          }
        }
        this.Year = this.propYear
        this.Month = this.propMonth
        this.Day = this.popDay
      },
      immediate: true
    },
    innerDate: {
      handler (newVal) {
        if (newVal) {
          this.$emit('input', newVal)
        } else {
          this.$emit('input', '')
        }
      }
    },
    recYYSync (v) {
      !v && (this.Year = '')
    },
    recMMSync (v) {
      !v && (this.Month = '')
    },
    recDDSync (v) {
      !v && (this.Day = '')
    }
  },
  methods: {}
}
</script>
